export const invoiceNumberFromId = (invoiceId: string): string =>
  `INV-${invoiceId}`;
